<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toc-title"><i>Contents</i></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody>
<tr>
<td align="left" colspan="2" valign="top"><p class="tocx"><a href="#/xhtml/06_Acknowledgements">Acknowledgements</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/07_Chapter01">1</a></p></td>
<td align="left" valign="top"><p class="toc1a"><a href="#/xhtml/07_Chapter01">Introduction</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/08_Chapter02">2</a></p></td>
<td align="left" valign="top"><p class="toc1a"><a href="#/xhtml/08_Chapter02">Operation Weserübung</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/09_Chapter03">3</a></p></td>
<td align="left" valign="top"><p class="toc1a"><a href="#/xhtml/09_Chapter03">The Dangers of Improvisation</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/10_Chapter04">4</a></p></td>
<td align="left" valign="top"><p class="toc1a"><a href="#/xhtml/10_Chapter04">War Throughout the Land</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample">5</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample">Romsdalsfjorden – Sickleforce</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample">6</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample">Namsos – Mauriceforce</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample">7</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample">Carrier Task Force</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample">8</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample">Cutting the Losses</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/15_Chapter09" title="Link target outside of Sample">9</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/15_Chapter09" title="Link target outside of Sample">Events in the South</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/16_Chapter10" title="Link target outside of Sample">10</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/16_Chapter10" title="Link target outside of Sample">A Winter’s Tale</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/17_Chapter11" title="Link target outside of Sample">11</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/17_Chapter11" title="Link target outside of Sample">The Long Retreat</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/18_Chapter12" title="Link target outside of Sample">12</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/18_Chapter12" title="Link target outside of Sample">Withdrawal</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/19_Chapter13" title="Link target outside of Sample">13</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/19_Chapter13" title="Link target outside of Sample">Operation Juno</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/20_Chapter14" title="Link target outside of Sample">14</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/20_Chapter14" title="Link target outside of Sample">Epilogue</span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc"><span href="#/xhtml/21_Appendix01#Appendix01" title="Link target outside of Sample">Appendices</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/21_Appendix01" title="Link target outside of Sample">A</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/21_Appendix01" title="Link target outside of Sample">Ships in Service with the Royal Norwegian Navy, April 1940</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/22_Appendix02" title="Link target outside of Sample">B</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/22_Appendix02" title="Link target outside of Sample">Main Units of the Norwegian Army c.15 April 1940</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/23_Appendix03" title="Link target outside of Sample">C</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/23_Appendix03" title="Link target outside of Sample">The German Army in Norway, 1940</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/24_Appendix04" title="Link target outside of Sample">D</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/24_Appendix04" title="Link target outside of Sample">Luftwaffe Units in Norway, April-May 1940</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/25_Appendix05" title="Link target outside of Sample">E</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/25_Appendix05" title="Link target outside of Sample">Allied Vessels Involved in the Norwegian Campaign</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/26_Appendix06" title="Link target outside of Sample">F</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/26_Appendix06" title="Link target outside of Sample">Allied Land Forces Involved in the Norwegian Campaign</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/27_Appendix07" title="Link target outside of Sample">G</span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/27_Appendix07" title="Link target outside of Sample">Allied Personnel Involved with the Norwegian Government</span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc"><span href="#/xhtml/28_Abbreviations_and_Glossaries" title="Link target outside of Sample">Abbreviations and Glossaries</span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc"><span href="#/xhtml/29_Notes" title="Link target outside of Sample">Notes</span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toca"><span href="#/xhtml/30_References" title="Link target outside of Sample">References</span></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?a74abb06